export default __webpack_public_path__ + "static/media/euclid.865722cd.png";